import {Directive, ElementRef, Output, EventEmitter, HostListener, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective implements OnDestroy {
    @Output() public clickOutside: EventEmitter<any> = new EventEmitter();

    /*constructor(private _elementRef: ElementRef) {
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        /!*console.log('오프클릭확인: targetElement=' + targetElement + '===' + clickedInside );*!/
        if (!clickedInside) {
            this.clickOutside.emit(null);
        }
    }*/

    private subscription: Subscription;
    private documentBodyElement: HTMLElement;
    private baseElement: HTMLElement;

    constructor(private el: ElementRef) {
        this.baseElement = this.el.nativeElement;
        this.documentBodyElement = document.body;
        this.subscription = Observable.fromEvent(document, 'click')
            .subscribe((event: Event) => this.clickHandler(event.srcElement, event));
    }

    private clickHandler(currentElement: HTMLElement | Element, event: Event): void {
        if (currentElement === this.documentBodyElement || currentElement == null) {
            this.clickOutside.emit(event);
            return;
        }
        if (currentElement === this.baseElement) {
            return;
        }
        this.clickHandler(currentElement.parentElement, event);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/click-outside/click-outside.directive.ts